import React from "react";
import { useHistory } from "react-router";
import { updateInstituteContactDetails } from "../../../APIs/PostAPIS";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
import Notification from "../../Portals/Notification/Notification";
import "./contact-person-details.style.scss";
export default function ContactPersonDetails({currentRoute}) {
  const context = React.useContext(MainContext)
  const {initialChecking} = context
  const phoneRegex = /^(\d){9,12}$/;
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });
  const [contactDetails, setContactDetails] = React.useState({
    institution_contact_name: "",
    institution_primary_email: "",
    institution_alternative_email: "",
    institution_primary_contact_no: "",
    institution_alternative_contact_no: "",
  });
  const clearNotification = () => {
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: "",
      });
      // changeRoute()
      history.push("/institute/profile");
      setLoading(false);
      clearTimeout(a);
    }, [1000]);
  };
  const handleUpdate = async () => {
    try {
      setLoading(true);
      let res = await updateInstituteContactDetails(contactDetails);
      if (res.data.data) {
        initialChecking()
        setNotification({
          status: true,
          title: `Institute Details Updated`,
          moreDetails: `Update Others`,
        });
        clearNotification();
      }
    } catch (error) {}
  };
  React.useEffect(()=>{
    currentRoute()
  },[])
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleUpdate();
      }}
      className="contact-person-details"
    >
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      <header className="cpd-header">
        <h5>Step 2: Contact Person Details</h5>
      </header>
      <section className="cpd-body">
        <div className="fancy-input-wrapper">
          <span>Full name*</span>
          <input
            required
            value={contactDetails.institution_contact_name}
            onChange={(e) =>
              setContactDetails({
                ...contactDetails,
                institution_contact_name: e.target.value,
              })
            }
            placeholder=""
          />
        </div>
        <div className="fancy-input-wrapper phone">
          <span>Mobile Number*</span>
          <div>
            <input value="+91" disabled type="" />
            <input
              required
              value={contactDetails.institution_primary_contact_no}
              onChange={(e) =>
                setContactDetails({
                  ...contactDetails,
                  institution_primary_contact_no: e.target.value,
                })
              }
              pattern="^(\d){9,12}$"
              placeholder="XXXXXXXXXX"
            />
          </div>
        </div>

        <div
          className={`fancy-input-wrapper phone ${
            contactDetails.institution_primary_contact_no &&
            contactDetails.institution_primary_contact_no ===
              contactDetails.institution_alternative_contact_no
              ? "error"
              : ""
          }`}
        >
          <span>Alternate Mobile Number</span>
          <p>Use different number</p>
          <div>
            <input value="+91" disabled type="" />
            <input
              // required
              value={contactDetails.institution_alternative_contact_no}
              onChange={(e) =>
                setContactDetails({
                  ...contactDetails,
                  institution_alternative_contact_no: e.target.value,
                })
              }
              pattern="^(\d){9,12}$"
              placeholder="XXXXXXXXXX"
            />
          </div>
        </div>
        <div className="fancy-input-wrapper">
          <span>Email ID*</span>
          <input
            required
            value={contactDetails.institution_primary_email}
            onChange={(e) =>
              setContactDetails({
                ...contactDetails,
                institution_primary_email: e.target.value,
              })
            }
            placeholder=""
            type="email"
          />
        </div>

        <div
          className={`fancy-input-wrapper ${
            contactDetails.institution_primary_email &&
            contactDetails.institution_primary_email ===
              contactDetails.institution_alternative_email
              ? "error"
              : ""
          }`}
        >
          <span>Alternate Email ID</span>
          <p>Use different email</p>
          <input
            // required
            value={contactDetails.institution_alternative_email}
            onChange={(e) =>
              setContactDetails({
                ...contactDetails,
                institution_alternative_email: e.target.value,
              })
            }
            placeholder=""
            type="email"
          />
        </div>
      </section>
      <footer>
        <button
          disabled={
            contactDetails.institution_primary_contact_no ===
              contactDetails.institution_alternative_contact_no ||
            contactDetails.institution_primary_email ===
              contactDetails.institution_alternative_email
          }
          type="submit"
        >
          {loading ? "Submitting...." : "Submit"}
        </button>
      </footer>
    </form>
  );
}
